import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module';
import { DataTableModule } from 'angular-datatables-all-versions';
import { DonationsListComponent } from './donations-list.component';
import { DonationsListResolver } from './donations-list.resolver';
import {AssociationsForFilterResolver} from '../../associations/associations-for-filter/associations-for-filter.resolver';
import { FilterDonationComponent } from './filter-donation/filter-donation.component';
import { BsDatepickerModule } from 'ngx-bootstrap';

@NgModule({
    imports: [
      NgbModule,
      SharedModule,
      DataTableModule,
      BsDatepickerModule
    ],
    declarations: [DonationsListComponent, FilterDonationComponent],
    entryComponents: [FilterDonationComponent],
    exports: [DonationsListComponent],
    providers: [DonationsListResolver, AssociationsForFilterResolver]
  })
  export class DonationsListModule {}
